/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ISaveStatus } from '../models/ISaveStatus';
import type { KYCAuditLogViewModel } from '../models/KYCAuditLogViewModel';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class KycAuditLogService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public kycAuditLogLogKycDocumentUpload(
        requestBody: KYCAuditLogViewModel,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/kycauditlog/logkycupload',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public kycAuditLogLogKycDocumentDownload(
        requestBody: KYCAuditLogViewModel,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/kycauditlog/logkycdownload',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ISaveStatus
     * @throws ApiError
     */
    public kycAuditLogLogKycDocumentDelete(
        requestBody: KYCAuditLogViewModel,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/kycauditlog/logkycdelete',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
